module.exports = __webpack_public_path__ + "assets/img/teacher (65).54065a6c.png";